import comp from "./AddChildModal";
export default comp;
